<app-attachment-upload
  *ngIf="!selectFromExisting"
  (done)="onDone($event)"
  (switchToRecentFiles)="selectFromExisting = true"
  (close)="onClose()"
  [options]="data.uploadOptions"
></app-attachment-upload>
<app-attachment-select
  *ngIf="selectFromExisting"
  (done)="onDone($event)"
  (close)="onClose()"
  [allowedFileExtensions]="data.uploadOptions?.allowedFileExtensions"
></app-attachment-select>
